
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefinementView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstSurname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"case"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"caseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cases"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doctor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"patientName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientSurname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"refinements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"v2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"goals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unfit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unfit1Image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unfit2Image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xray1Image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xray2Image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lateralFacialImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frontalFacialImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smileFacialImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upperOcclusalImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowerOcclusalImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rightIntraoralImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"centralIntraoralImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leftIntraoralImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"typeOfImpressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"typeOfImpressionsAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upperIntraoralScanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lowerIntraoralScanner"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":989}};
    doc.loc.source = {"body":"query RefinementView($caseId: String) {\n  me {\n    name\n    firstSurname\n    role\n    username\n    image\n\n    notifications {\n      case\n      seen\n      createdAt\n      description\n      patientName\n      description\n      kind\n      image\n    }\n\n    cases(caseId: $caseId) {\n      cases {\n        id\n        doctor {\n          username\n        }\n        patientName\n        patientSurname\n\n        refinements {\n          v2\n          id\n          attachments\n          created\n          goals\n          unfit\n          unfit1Image\n          unfit2Image\n          xray1Image\n          xray2Image\n          lateralFacialImage\n          frontalFacialImage\n          smileFacialImage\n          upperOcclusalImage\n          lowerOcclusalImage\n          rightIntraoralImage\n          centralIntraoralImage\n          leftIntraoralImage\n          typeOfImpressions\n          typeOfImpressionsAddress\n          upperIntraoralScanner\n          lowerIntraoralScanner\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RefinementView"] = oneQuery(doc, "RefinementView");
        
